import secondsSinceOnline from "./secondsSinceOnline";

export const onlineAccessor = ({ online }) => {
	return secondsSinceOnline(online) < 61;
};
